import http from "../config/axiosConfig/http-common";
import { GetOperacoes, SetOperacoes } from "../config/localstorageConfig/localstorage";
import ServiceBase from "./service.base";

class OperacaoVendaService extends ServiceBase {

    getAll(filter) {
        //return http.get("/atributos" + this.getFilter(filter));
        return http.get("/operacoesvenda");
    }

    async setCache() {
        const atributos = GetOperacoes();
        if (atributos) {
            return
        }

        try {
            const response = await http.get("/operacoesvenda");
            SetOperacoes(response.data.value);
        } catch (e) {
            console.error("Erro ao carregar operacoesvenda:", e);
            throw e;
        }
    }

    get(id) {
        return http.get(`/operacoesvenda/${id}`);
    }
}

export default new OperacaoVendaService();
